<template>
  <button
    v-tooltip.bottom="tooltipText"
    :class="{
      'transition hover:bg-gray-200': isDownloadable,
    }"
    :disabled="!isDownloadable"
  >
    <span class="sr-only">{{
      $t("legal_text.textEditor.tooltips.pdf_download")
    }}</span>
    <DownloadIcon
      class="h-5 w-5"
      :class="[isDownloadable ? 'text-black' : 'text-gray-300']"
      aria-hidden="true"
      :alt="$t('legal_text.textEditor.tooltips.pdf_download')"
    />
  </button>
</template>

<script lang="ts" setup>
import DownloadIcon from "~/assets/editor/download_pdf.svg";

type Props = {
  isDownloadable: boolean;
  tooltipText: string;
};

defineProps<Props>();
</script>
